/**
 * Runtime environment access. Every `import.meta.env` read in the app
 * funnels through here so values can be validated and defaulted once.
 */

const raw = import.meta.env ?? {};

function required(key, fallback) {
  const value = raw[key] ?? fallback;
  if (value === undefined && raw.PROD) {
    // eslint-disable-next-line no-console
    console.warn(`[env] Missing required variable: ${key}`);
  }
  return value;
}

export const env = Object.freeze({
  mode: raw.MODE ?? "development",
  isProd: Boolean(raw.PROD),
  isDev: Boolean(raw.DEV),
  apiBaseUrl: required("VITE_API_BASE_URL", "/api"),
  web3formsAccessKey: raw.VITE_WEB3FORMS_KEY ?? "",
  analyticsId: raw.VITE_ANALYTICS_ID ?? "",
  siteUrl: raw.VITE_SITE_URL ?? "https://mercoris.com",
});

export default env;
